export default "__VITE_ASSET__DdbQdG2R__"